var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "itemPreviewModal", tabindex: "-1", role: "dialog" },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog overflow-x-hidden modal-dialog-scrollable",
        },
        [
          _c("div", { staticClass: "modal-content overflow-x-hidden" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm.item != null
                ? _c("h4", {
                    staticClass: "modal-title font-weight-bold",
                    domProps: { innerHTML: _vm._s(_vm.itemName) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._m(0),
            ]),
            _vm._v(" "),
            _vm.item != null
              ? _c(
                  "div",
                  {
                    staticClass:
                      "modal-body overflow-x-hidden position-relative",
                  },
                  [
                    _vm.item.item.free1 && _vm.item.item.free1.length > 1
                      ? _c("div", { staticClass: "highlight-content" }, [
                          _c(
                            "span",
                            { staticClass: "bg-danger text-white px-2 py-1" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.item.item.free1) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "thumb-wishlist" },
                      [
                        _c("add-to-wish-list", {
                          attrs: { "variation-id": _vm.item.variation.id },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "item-images mb-5",
                        style: { visibility: _vm.visibleStatus },
                      },
                      [
                        _c("category-image-carousel", {
                          key: _vm.item.item.id,
                          ref: "categoryImageCarousel",
                          attrs: {
                            "image-urls-data": _vm._f("itemImages")(
                              _vm.item.images,
                              _vm.imageUrlAccessor
                            ),
                            alt: _vm._f("itemName")(_vm.item),
                            title: _vm._f("itemName")(_vm.item),
                            "item-url": _vm._f("itemURL")(
                              _vm.item,
                              _vm.urlWithVariationId
                            ),
                            "show-dots": true,
                            "show-nav": true,
                            "enable-carousel": true,
                            "disable-lazy-load": true,
                            "disable-carousel-on-mobile": false,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-4", class: { "pt-4": !_vm.category } },
                      [
                        _vm.category
                          ? _c("div", { staticClass: "mb-2" }, [
                              _c("small", {
                                staticClass: "text-primary",
                                domProps: { innerHTML: _vm._s(_vm.category) },
                              }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "h4",
                          { staticClass: "font-weight-bold" },
                          [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(_vm.itemName) },
                            }),
                            _vm._l(
                              _vm.item.groupedAttributes,
                              function (attribute) {
                                return _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "Ceres::Template.itemGroupedAttribute",
                                        attribute
                                      )
                                    )
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-content-center mb-5",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "w-100 d-flex align-items-center flex-wrap",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "feedback-stars-average feedback-category-view own mr-2",
                                attrs: { id: "feedback-stars-average" },
                              },
                              [
                                _vm._m(1),
                                _vm._v(" "),
                                _vm.item.item.feedbackDecimal > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "feedback-stars-overlay-wrap",
                                        style: { width: _vm.fillStars },
                                      },
                                      [_vm._m(2)]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.item.item.feedbackCount > 0
                              ? _c("div", { staticClass: "feedback-count" }, [
                                  _c("span", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.item.item.feedbackCount) +
                                        " " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Feedback::Feedback.customerReviews"
                                          )
                                        ) +
                                        ")"
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "availability pl-3",
                            class: {
                              "text-success":
                                _vm.item.variation.availability.id == 1,
                              "text-warning":
                                _vm.item.variation.availability.id > 1 &&
                                _vm.item.variation.availability.id < 7,
                              "text-danger":
                                _vm.item.variation.availability.id > 6,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa",
                              class: {
                                "fa-check-circle":
                                  _vm.item.variation.availability.id === 1 ||
                                  _vm.item.variation.availability.id === 3,
                                "fa-times-circle":
                                  _vm.item.variation.availability.id === 7,
                                "fa-circle":
                                  _vm.item.variation.availability.id !== 1 &&
                                  _vm.item.variation.availability.id !== 3 &&
                                  _vm.item.variation.availability.id !== 7,
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.item.variation.availability.names.name
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.item.item.free2 === "1"
                      ? _c("div", { staticClass: "text-right mb-1" }, [
                          _c("div", { staticClass: "d-inline-block" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "1.25rem",
                                  height: "1.25rem",
                                  preserveAspectRatio: "xMidYMid meet",
                                  viewBox: "0 0 640 512",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "#d4021d",
                                    d: "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5c-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64L69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z",
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-inline-block text-primary font-weight-bold",
                            },
                            [_vm._v("GONSERBOX")]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row align-items-center mb-5" }, [
                      _c("div", { staticClass: "col-7 col-sm-6" }, [
                        _c("ul", { staticClass: "fa-ul list-unstyled" }, [
                          _c("li", { staticClass: "buy-box-check mb-2" }, [
                            _c("i", {
                              staticClass:
                                "fa fa-check-square-o fa-li text-success",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "GonserDT::Template.itemUspGuarantee"
                                  )
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "buy-box-check mb-2" }, [
                            _c("i", {
                              staticClass:
                                "fa fa-check-square-o fa-li text-success",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "GonserDT::Template.itemUspRefund"
                                  )
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _vm.item.variation.availability.id == 1
                            ? _c("li", { staticClass: "buy-box-check" }, [
                                _c("i", {
                                  staticClass:
                                    "fa fa-check-square-o fa-li text-success",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$translate(
                                        "GonserDT::Template.itemUspDelivery"
                                      )
                                    ),
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-5 col-sm-6 buy-box-inner-right text-right pl-0",
                        },
                        [
                          _c("div", { staticClass: "prices text-right" }, [
                            _vm.item.prices.rrp &&
                            _vm.item.prices.rrp.unitPrice.value > 0 &&
                            _vm.item.prices.rrp.unitPrice.value >
                              _vm.item.prices.default.unitPrice.value
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "calculated text-primary font-weight-bold mb-1",
                                  },
                                  [
                                    _vm.item.prices.specialOffer
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "GonserDT::Template.itemYouSave",
                                                  {
                                                    value: (
                                                      ((_vm.item.prices.rrp
                                                        .unitPrice.value -
                                                        _vm.item.prices
                                                          .specialOffer
                                                          .unitPrice.value) /
                                                        _vm.item.prices.rrp
                                                          .unitPrice.value) *
                                                      100
                                                    ).toFixed(2),
                                                  }
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "GonserDT::Template.itemYouSave",
                                                  {
                                                    value: (
                                                      ((_vm.item.prices.rrp
                                                        .unitPrice.value -
                                                        _vm.item.prices.default
                                                          .unitPrice.value) /
                                                        _vm.item.prices.rrp
                                                          .unitPrice.value) *
                                                      100
                                                    ).toFixed(2),
                                                  }
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.prices.rrp &&
                            _vm.item.prices.rrp.price.value > 0 &&
                            _vm.item.prices.rrp.price.value >
                              _vm.item.prices.default.unitPrice.value &&
                            _vm.item.variation.availability.id < 5
                              ? _c("div", { staticClass: "price-view-port" }, [
                                  _vm.item.prices.specialOffer
                                    ? _c(
                                        "div",
                                        { staticClass: "crossprice mb-0" },
                                        [
                                          _c(
                                            "del",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "GonserDT::Template.itemYouSave",
                                                      {
                                                        value: (
                                                          ((_vm.item.prices.rrp
                                                            .unitPrice.value -
                                                            _vm.item.prices
                                                              .default.unitPrice
                                                              .value) /
                                                            _vm.item.prices.rrp
                                                              .unitPrice
                                                              .value) *
                                                          100
                                                        ).toFixed(2),
                                                      }
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c("div", { staticClass: "crossprice" }, [
                                        _c(
                                          "del",
                                          { staticClass: "text-muted" },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "GonserDT::Template.itemUvp",
                                                    {
                                                      price:
                                                        _vm.$options.filters.currency(
                                                          _vm.item.prices.rrp
                                                            .unitPrice.value,
                                                          " "
                                                        ),
                                                    }
                                                  )
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "price" }, [
                              _c("span", { staticClass: "custom_currency" }, [
                                _vm._v("CHF"),
                              ]),
                              _vm.item.prices.specialOffer
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "custom_price h1 font-weight-bolder text-primary",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.item.prices.specialOffer
                                                .unitPrice.value,
                                              " "
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "custom_price h1 font-weight-bolder text-primary",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.item.prices.default.unitPrice
                                                .value,
                                              " "
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "vat small text-muted text-right",
                              },
                              [
                                _vm.item.item.free2 === "1"
                                  ? _c(
                                      "span",
                                      { staticClass: "shippings-out" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.singleItemExclusive"
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "shippings-in" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.singleItemIncludeAbbr"
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemShippingCosts"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item-description-container" }, [
                      _c(
                        "div",
                        { staticClass: "item-description gonser-list-style" },
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.item.texts.description),
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer d-block" }, [
              _vm.item != null
                ? _c("div", { staticClass: "row" }, [
                    _vm.item.variation.availability.id < 5
                      ? _c("div", { staticClass: "col-6 pl-0" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-default btn-block w-100",
                              attrs: {
                                href: _vm._f("itemURL")(
                                  _vm.item,
                                  _vm.urlWithVariationId
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$translate(
                                      "GonserDT::Template.generalToItem"
                                    )
                                  )
                              ),
                              _c("i", { staticClass: "fa fa-arrow-right" }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-6 pr-0",
                        on: {
                          click: function ($event) {
                            return _vm.close()
                          },
                        },
                      },
                      [
                        _c(
                          "client-only",
                          [
                            _c("add-to-basket", {
                              attrs: {
                                "variation-id": _vm.item.variation.id,
                                "is-salable":
                                  !!_vm.item.filter &&
                                  _vm.item.filter.isSalable,
                                "has-children":
                                  !!_vm.item.item &&
                                  _vm.item.item.salableVariationCount > 1,
                                "interval-quantity":
                                  _vm.item.variation.intervalOrderQuantity || 1,
                                "minimum-quantity":
                                  _vm.item.variation.minimumOrderQuantity,
                                "maximum-quantity":
                                  !!_vm.item.variation.maximumOrderQuantity &&
                                  _vm.item.variation.maximumOrderQuantity > 0
                                    ? _vm.item.variation.maximumOrderQuantity
                                    : null,
                                "order-properties": _vm.item.properties.filter(
                                  function (prop) {
                                    return prop.property.isOderProperty
                                  }
                                ),
                                "has-order-properties":
                                  _vm.item.hasOrderProperties,
                                "has-required-order-property":
                                  _vm.item.hasRequiredOrderProperty,
                                "use-large-scale": false,
                                "show-quantity": false,
                                "is-wish-list": true,
                                "item-url": _vm._f("itemURL")(
                                  _vm.item,
                                  _vm.urlWithVariationId
                                ),
                                "has-price": _vm._f("hasItemDefaultPrice")(
                                  _vm.item
                                ),
                                "with-success-icon": true,
                                "item-type": _vm.item.item.itemType,
                                "event-stop": false,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "feedback-stars-background clearfix" }, [
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "feedback-stars-overlay clearfix" }, [
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }